import { useHistory } from 'react-router-dom'

import { getAppURL } from '~/shared/utils'

/**
 *
 */
function getLoginAppURL(action = 'login') {
  // @ts-expect-error TS(2345) FIXME: Argument of type '"login"' is not assignable to pa... Remove this comment to see the full error message
  const baseURL = getAppURL('login')
  // @ts-expect-error TS(2345) FIXME: Argument of type '"engage"' is not assignable to p... Remove this comment to see the full error message
  const engageURL = getAppURL('engage')

  const params =
    action === 'login'
      ? // @ts-expect-error TS(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
        `redirect=${encodeURIComponent(engageURL)}`
      : 'product=engage'

  return `${baseURL}/${action}?${params}`
}

/**
 *
 */
const useAccountCredentials = () => {
  const history = useHistory()

  // @ts-expect-error TS(7006) FIXME: Parameter 'account' implicitly has an 'any' type.
  const checkEngageAccess = (account) => {
    if (!account) {
      return false
    }

    const organization = account.currentOrganization
    if (!organization?.id) {
      return false
    }

    const { billing } = organization
    const { canAccessEngagement } = billing || {}

    if (!canAccessEngagement) {
      return false
    }

    // @ts-expect-error TS(7006) FIXME: Parameter 'el' implicitly has an 'any' type.
    if (!account?.products?.find((el) => el.name === 'engage')) {
      window.location.assign(getLoginAppURL('signup'))
      return false
    }

    return true
  }

  return { checkEngageAccess }
}

export default useAccountCredentials
